var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 72,
    viewBox: "0 0 112 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.005 6.56073V62.4092H2.09829V6.55317C2.09829 4.26211 3.72987 2.45475 5.65944 2.45475H105.438C107.374 2.45475 109.005 4.26211 109.005 6.56073ZM105.438 1.53125H5.65944C3.18823 1.53125 1.23438 3.82362 1.23438 6.55317V66.0093C1.23438 68.7467 3.18847 71.0312 5.65944 71.0312H105.438C107.915 71.0312 109.863 68.7464 109.863 66.0093V6.55317C109.863 3.81578 107.909 1.53125 105.438 1.53125ZM109.005 66.0093C109.005 68.3007 107.374 70.1153 105.438 70.1153H5.65944C3.72351 70.1153 2.09167 68.3007 2.09167 66.0093V63.3327H109.005V66.0093Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.833 14.3345L21.3398 49.5151",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7268 14.3878C91.5746 14.8264 91.6805 15.4844 91.826 15.9079C91.9782 15.1667 92.2627 14.4407 92.7325 13.8811C92.0576 13.9038 91.4092 13.6164 90.8203 13.261C91.0188 13.692 91.3232 14.1836 91.7268 14.3802V14.3878Z",
    fill: "#F69A4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4393 49.4627C21.8231 49.6366 22.1738 50.1736 22.3458 50.5819C21.7701 50.2038 21.1085 49.9542 20.4336 49.9618C20.9034 49.4173 21.1614 48.6686 21.3401 47.9351C21.479 48.3964 21.5915 48.9862 21.4393 49.4551V49.4627Z",
    fill: "#F69A4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0877 7.39282H10.1328V14.199",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0877 7.39282H10.1328V14.199",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0877 56.859H10.1328V50.0527",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1211 7.39282H103.076V14.199",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1211 56.859H103.076V50.0527",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.3746e58a2b56aa4e27ad75a39c3549be.svg";
export { ForwardRef as ReactComponent };